// extracted by mini-css-extract-plugin
export default {"EmptyBlock":"EmptyBlock_gj10WnJbJZC","EmptyBlock_message":"EmptyBlock_message3B_FBkeZcRHv","EmptyBlock-settings-button":"EmptyBlock-settings-button3yLoOuSxJXcK"};